import { useMatomo } from "@datapunt/matomo-tracker-react";
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { useLogger } from "../services/LogService";

export function useHistoryTracking() {
  const logger = useLogger("Matamo");

  const history = useHistory();

  const [currentRoute, setCurrentRoute] = useState("");

  const { trackPageView, pushInstruction } = useMatomo();

  useEffect(() => {
    return history.listen((location) => {
      const newRoute = location.pathname;
      if (newRoute !== currentRoute) {
        setCurrentRoute(newRoute);

        logger.info("Track current route: " + newRoute);

        pushInstruction("setCustomUrl", currentRoute);

        //matomo tracker
        trackPageView({
          documentTitle: document.title,
          href: newRoute,
        });
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history]);

  return { currentRoute: currentRoute };
}
